module.exports = __webpack_public_path__ + "static/media/news2.3aac183b.png";